import 'react-simple-hook-modal/dist/styles.css';
import React from 'react';
import image from '../../../../images/sites/1.PNG';

import {
      Modal,
      useModal,
      ModalTransition,
} from 'react-simple-hook-modal';

const Rabeyasm = () => {

      const { isModalOpen, openModal, closeModal } = useModal();

      return (
            <div className="col-md-6">
                  <div data-aos="zoom-in-right">
                        <img onClick={openModal} src={image} data-tip="Click to open Project" className="img-fluid sites link px-5" alt="" srcset="" />
                  </div>
                  <Modal
                        modalClassName="rsm-bg-gray-700"
                        id="any-unique-identifier"
                        isOpen={isModalOpen}
                        transition={ModalTransition.BOTTOM_UP}
                  >
                        <button onClick={closeModal} className='btn'><i style={{ fontSize: '30px' }} class="fas fa-times-circle brand"></i></button>

                        <div className="container">
                              <img className='img-fluid' src={image} alt="" />
                              <h2 className='fs-4 mt-3 text-white text-uppercase'>Rabeya's Food & Fitness Center</h2>
                              <div className="mt-2">
                                  
                                          <a href="https://rabeya-food-fitness.web.app/" target="_blank" rel='noreferrer'>
                                                <button style={{ backgroundColor: 'rgb(220, 90, 90)'}} className='btn site-static-button'>VISIT WEBSITE</button>
                                          </a>
                                  
                                   
                                          <a href="https://github.com/iamraufu/rabeya-food-fitness" target="_blank" rel='noreferrer'>
                                                <button className='btn hvr-sweep-to-right ms-3'>KNOW MORE</button>
                                          </a>
                                   
                              </div>
                              <p className='text-white mt-2'>Country's First ever Complex site where anyone can get nutritionist help along with healthy food diet.</p>
                              <ul>
                                    <li>Implemented Socket.io for <b className='brand brand-link'>one-to-one video consultation </b>for nutritionist and client</li>
                                    <li>Created user friendly UI and made responsive using <b className='brand brand-link'>BootStrap5</b></li>
                                    <li>Created eye-catching dashboard with food add, remove, orders, review features for both admin and users and build the whole System in <b className='brand brand-link'>ReactJS</b>, <b className='brand brand-link'>Node JS</b>, <b className='brand brand-link'>MongoDB</b> and <b className='brand brand-link'>Firebase</b>.</li>
                              </ul>
                        </div>
                        <button onClick={closeModal} style={{ backgroundColor: 'rgb(220, 90, 90)'}} className='w-100 btn site-static-button'>CLOSE</button>
                  </Modal>
            </div>
      );
};

export default Rabeyasm;